/* eslint no-underscore-dangle: 0 */
import { useMemo } from 'react';
import { DataServiceFactory, useDataService } from './ApiDataService';

const baseUrl = '/ipm/v1/navMenu';

export default function DashboardMenuServiceFactory(dataService = DataServiceFactory()) {
    function cleanId(dashboard) {
        return {
            ...dashboard,
            id: dashboard._id,
        };
    }

    function cleanIds(dashboardMenu) {
        return {
            id: dashboardMenu._id,
            privateDashboards: dashboardMenu.privateDashboards.map(cleanId),
            sharedDashboards: dashboardMenu.sharedDashboards.map(cleanId),
        };
    }

    function get() {
        return dataService.get(baseUrl).then(cleanIds);
    }

    function update(dashboardMenu) {
        return dataService
            .put(
                `${baseUrl}/${dashboardMenu.id}`,
                dashboardMenu,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then(cleanIds);
    }

    return {
        get,
        update,
    };
}

export function useDashboardMenuService() {
    const dataService = useDataService();
    return useMemo(() => DashboardMenuServiceFactory(dataService), [dataService]);
}
